module.exports = __webpack_public_path__ + "static/media/home-bg-3.1f9bf235.jpg";